<div class="dialog-content-wrapper">
    <mat-toolbar class="mat-primary m-0">
        <mat-toolbar-row
            fxFlex
            fxLayout="row"
            fxLayoutAlign="space-between center"
        >
            <span class="title dialog-title text-truncate"
                >Avance - OOTT {{ data.idOOTT }}</span
            >
            <button
                style="float: right"
                mat-icon-button
                (click)="dialogRef.close()"
                aria-label="Close dialog"
            >
                <mat-icon>close</mat-icon>
            </button>
        </mat-toolbar-row>
    </mat-toolbar>

    <mat-dialog-content class="p-16 pb-0 m-0">
        <table class="simple">
            <thead>
                <tr>
                    <th>#</th>
                    <th>Fecha</th>
                    <th>Descripción</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let avance of avances; let idx = index">
                    <td>{{ idx + 1 }}</td>
                    <td>
                        <strong
                            >{{ avance.fecha | date: "dd-MM-yyyy HH:mm" }}
                        </strong>
                        <button
                            *ngIf="
                                _menuUsuarioSrvc.esSupervisor() &&
                                avance.latitud !== 0 &&
                                avance.longitud !== 0
                            "
                            mat-icon-button
                            type="button"
                            color="accent"
                            (click)="verUbicacion(avance)"
                        >
                            <mat-icon>location_on</mat-icon>
                        </button>
                        <button
                            mat-icon-button
                            type="button"
                            color="accent"
                            *ngIf="avance.fotosIds.length > 0"
                            (click)="verImagenes(avance.fotosIds)"
                        >
                            <mat-icon>image</mat-icon>
                        </button>
                    </td>

                    <td>
                        <strong>Observación</strong><br />
                        {{ avance.descripcion }} <br />
                        <div *ngIf="avance.rutPersona">
                            <strong>Persona que toma conocimiento</strong><br />

                            <small>
                                <strong>Rut:</strong> {{ avance.rutPersona
                                }}<br />
                                <strong>Nombre:</strong>
                                {{ avance.nombrePersona }}
                            </small>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
        <div class="message-box info" *ngIf="avances?.length === 0">
            No hay avances de este trabajo por el momento
        </div>
    </mat-dialog-content>
    <mat-divider></mat-divider>
    <mat-dialog-actions
        class="m-0 p-16"
        fxLayout="row"
        fxLayoutAlign="end center"
    >
        <button mat-raised-button color="accent" mat-dialog-close>
            Cerrar
        </button>
    </mat-dialog-actions>
</div>
